import { Navigate, useLocation } from 'react-router-dom'

import { unsetCurrentTenantConfig } from '..'
import { useAllTenants } from '../../../data/tenants'
import { ProjectConfigurator } from './ProjectConfigurator'

export const TenantConfigurator: React.FC = () => {
  const { pathname } = useLocation()
  const { data, error } = useAllTenants()

  if (error)
    return <>{unsetCurrentTenantConfig() && <Navigate to="/set-tenant" />}</>

  if (!data) return null

  if (data?.length === 1)
    return (
      <>
        <ProjectConfigurator tenantId={data[0].id} />
      </>
    )

  return (
    <>
      {pathname && !pathname.toLowerCase().startsWith('/set-tenant') && (
        <Navigate to="/set-tenant" />
      )}
    </>
  )
}
